module.exports = __webpack_public_path__ + "media/images/emblems/Morlon-coat_of_arms-61d8e1b31178fc4600085086fcdf37ee.svg";